import React from 'react';
import { Box, Center, Image } from '@chakra-ui/react';
import ugcPackageIcon from '../../assets/ugc-section-icon.svg';
import instagramChipGradient from '../../assets/instagram-chip-gradient.svg';
import instagramIcon from '../../assets/instagram-icon.svg';
import tiktokIcon from '../../assets/tiktok-icon.svg';

const CHIP_PX = '18px';
const RADIUS = '6px';

/** Figma 5737-102 (frame) + 5737-103: radial gradient, border, shadows, camera SVG. */
export const InstagramPlatformChip: React.FC = () => (
  <Box
    flexShrink={0}
    w={CHIP_PX}
    h={CHIP_PX}
    position="relative"
    borderRadius={RADIUS}
    border="1px solid"
    borderColor="rgba(0, 0, 0, 0.05)"
    boxShadow="0 1px 0.5px rgba(194, 65, 12, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, 0.35)"
    overflow="hidden"
  >
    <Image
      src={instagramChipGradient}
      alt=""
      position="absolute"
      inset={0}
      w="100%"
      h="100%"
      objectFit="cover"
      display="block"
    />
    <Center w="100%" h="100%" position="relative" zIndex={1}>
      <Image
        src={instagramIcon}
        alt=""
        w="11.15px"
        h="11.15px"
        flexShrink={0}
        display="block"
      />
    </Center>
  </Box>
);

/** Figma 5737-111: Background+Border+Shadow + SVG note mark. */
export const TikTokPlatformChip: React.FC = () => (
  <Box
    flexShrink={0}
    w={CHIP_PX}
    h={CHIP_PX}
    position="relative"
    borderRadius={RADIUS}
    border="1px solid"
    borderColor="rgba(0, 0, 0, 0.2)"
    bg="#1c1917"
    boxShadow="0 1px 0.5px rgba(15, 23, 42, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, 0.15)"
    overflow="hidden"
  >
    <Center w="100%" h="100%" position="relative" zIndex={1}>
      <Image
        src={tiktokIcon}
        alt=""
        w="11.15px"
        h="11.15px"
        flexShrink={0}
        display="block"
        aria-hidden
      />
    </Center>
  </Box>
);

export const UgcPackageIcon: React.FC = () => (
  <Image
    src={ugcPackageIcon}
    alt="UGC"
    flexShrink={0}
    w={CHIP_PX}
    h={CHIP_PX}
    borderRadius={RADIUS}
    display="block"
  />
);
